// extracted by mini-css-extract-plugin
export var menu = "header-and-sidenav-module--menu--90862";